import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { BeneficiosPrincipal_ } from '../../services/WebAPI_Utrahuilca';
import { URLImgFront } from '../../config/URLDB';

class Seccion1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            infoBeneficios: [],
            stateBene: true
        };
    }

    componentDidMount() {
        Aos.init({ duration: 1000 });
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idbenefutra: 0,
            titulobenef: 'NA',
            rutaiconobenef: 'NA',
            descbenef: 'NA',
            estado: 0,
            usucrea: 'NA'
        }
        BeneficiosPrincipal_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        if (response.data[0].message === "004404") {
                            this.setState({
                                stateBene: false
                            })
                        } else {
                            this.setState({
                                infoBeneficios: response.data,
                                stateBene: true
                            })
                        }
                    } else {
                        this.setState({
                            stateBene: false
                        })
                    }
                } else { }
            } catch (error) {
                console.log(error);
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className="section1">
                    <div className="pt-5">
                        <div className="titulo text-center justify-content-center d-flex">
                            <p className="font-weight-bold py-2 w-25 text-center" style={{ fontSize: '35px', color: '#707070' }}>CONOCE MÁS</p>
                        </div>
                        <div className="container">
                            <div className="row mt-3 px-2">
                                <div className="col-md-4 my-3 " data-aos="fade-right">
                                    <Link to="/Servicios">
                                        <div className="card card_online">
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid" style={{ width: '100%', maxHeight: '180px' }} src={`${URLImgFront}/assets/img-variadas/NuestrosServicios.webp`} alt="IMAG NUESTROS SERVICIOS" />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p style={{ color: '#707070' }}>Nuestros Servicios</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#72A4AD', fontSize: '17px' }}>Conócelos</div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-4 my-3" data-aos="fade-down">
                                    <Link to="/Cooperativa_Virtual">
                                        <div className="card card_online">
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid" style={{ width: '100%', maxHeight: '180px' }} src={`${URLImgFront}/assets/img-variadas/CooperativaVirtual.webp`} alt="IMAG COOPERATIVA VIRTUAL" />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p style={{ color: '#707070' }}>Cooperativa Virtual</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#72A4AD', fontSize: '17px' }}>Realiza tus operaciones en línea</div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-4 my-3" data-aos="fade-up">
                                    <Link to="/Beneficios">
                                        <div className="card card_online">
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid" style={{ width: '100%', maxHeight: '180px' }} src={`${URLImgFront}/assets/img-variadas/Beneficios.webp`} alt="IMAG BENEFICIOS" />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p style={{ color: '#707070' }}>Beneficios</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#72A4AD', fontSize: '17px' }}>Conócelos</div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div className="row px-2">
                                <div className="col-md-4 my-3" data-aos="fade-right">
                                    <Link to="/Descargar_Formatos">
                                        <div className="card card_online">
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid" style={{ width: '100%', maxHeight: '180px' }} src={`${URLImgFront}/assets/img-variadas/FormatosSolicitud.webp`} alt="IMAG FORMATOS" />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p style={{ color: '#707070' }}>Formatos de Solicitud</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#72A4AD', fontSize: '17px' }}>Descargar</div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-4 my-3" data-aos="fade-up">
                                    <Link to="/coopsejos">
                                        <div className="card card_online">
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid" style={{ width: '100%', maxHeight: '180px' }} src={`${URLImgFront}/assets/img-variadas/Noticias.webp`} alt="IMAG NOTICIAS" />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p style={{ color: '#707070' }}>Noticias</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#72A4AD', fontSize: '17px' }}>Entérate</div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-4 my-3" data-aos="fade-up">
                                    <a href="http://www.fundautrahuilca.org/" target={'_blank'} rel="noopener noreferrer">
                                        <div className="card card_online">
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid" style={{ width: '100%', maxHeight: '180px' }} src={`${URLImgFront}/assets/img-variadas/FundacionSocialUTRAHUILCA.webp`} alt="IMG FUNDAUTRAHUILCA" />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p style={{ color: '#707070' }}>Fundación Social UTRAHUILCA</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#72A4AD', fontSize: '17px' }}>Sitio Web</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Seccion1;